import { render, staticRenderFns } from "./TicketPart.vue?vue&type=template&id=2d8e71f6&scoped=true&"
import script from "./TicketPart.vue?vue&type=script&lang=js&"
export * from "./TicketPart.vue?vue&type=script&lang=js&"
import style0 from "./TicketPart.vue?vue&type=style&index=0&id=2d8e71f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8e71f6",
  null
  
)

export default component.exports